import { Injectable } from '@angular/core';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { AddCustomerVehicleResponseModel } from '../business-entities/add-customer-vehicle-model';
import { AddCustomerVehicleDataService } from '../data-services/add-customer-vehicle-data.service';

@Injectable({ providedIn: 'root' })
export class AddCustomerVehicleService {
    constructor(
        private VehicleCustomerDataService: AddCustomerVehicleDataService
    ) { }

    getCustomerAndVehicleDetails(licensePlate: string): Promise<GenericResponse<any>> {
        return this.VehicleCustomerDataService.getCustomerAndVehicleDetails(licensePlate);
    }

    getCustomerAndVehicleDetailsUsingMobile(mobileNo: string): Promise<GenericResponse<any>> {
        return this.VehicleCustomerDataService.getCustomerAndVehicleDetailsUsingMobile(mobileNo);
    }
    async getCustomerListUsingMobile(mobileNo: string,AdvanceMobile:string,customerNo:string,firstName:string): Promise<GenericResponse<any>> {
        return this.VehicleCustomerDataService.getCustomerListUsingMobile(mobileNo,AdvanceMobile,customerNo,firstName);
    }

    getBrandDetais(): Promise<GenericResponse<any>> {
        return this.VehicleCustomerDataService.getBrandDetais();
    }

    getCountryCodeAndMobileCodeDetails(): Promise<GenericResponse<any>> {
        return this.VehicleCustomerDataService.getCountryCodeAndMobileCodeDetails();
    }

    getFuelTypeDetails(): Promise<GenericResponse<any>> {
        return this.VehicleCustomerDataService.getFuelTypeDetails();
    }

    checkCustomerDetails(mobile: string): Promise<GenericResponse<any>> {
        return this.VehicleCustomerDataService.checkCustomerDetails(mobile);
    }

    AddCustomerVehicleDetails(model: AddCustomerVehicleResponseModel): Promise<GenericResponse<any>> {
        return this.VehicleCustomerDataService.AddCustomerVehicleDetails(model);
    }

    getVehicleDetailsFromDMSByVehicleno(vehicleNo: string): Promise<GenericResponse<any>> {
        return this.VehicleCustomerDataService.getVehicleDetailsFromDMSByVehicleno(vehicleNo);
    }

}
